import React, { useState,useEffect } from 'react';
import $ from 'jquery'; 
import Swal from 'sweetalert2';
import CS_program_details from './CS_program_details';
import CS_Pricing_card from './CS_Pricing_card';
import CS_Review_Program_Page from './CS_Review_Program_Page';
import CS_FAQ_page from './CS_FAQ_page';
import CS_curriculum_page from './CS_curriculum_page';
import CS_mobile_view_curriculum_page from './CS_mobile_view_curriculum_page';
import Certificates from '../Certificates';
import Counsellor from '../Counsellor';
import All_Program_Mentor from '../All_Program_Mentor';

function CS_page() {
  useEffect(()=>{
    document.title= 'Cyber Security | Traineeship Program | InternsElite';
  },[]);

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    collegeName: '',
    programName: '',
  });

  const [nameError, setNameError] = useState(" "); 
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [collegeError, setCollegeError] = useState("");
  const [programError, setProgramError] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`);
      }  
      else {
        setNameError("");
      }
    }
    
    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError("Invalid email format");
      } else {
        setEmailError("");
      }
    
    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError("Length Should be 10 Digit");
      } else {
        setPhoneError("");
      }
    }
    if (name === 'collegeName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setCollegeError(`Invalid College Name format.`);
      }  
      else {
        setCollegeError("");
      }
    }   
    if (name === 'programName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setProgramError(`Invalid College Name format.`);
      }  
      else {
        setProgramError("");
      }
    }  
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  

  const handleSubmit = async(event) => {
    event.preventDefault();
    $.ajax({
      url: 'https://forms.internselite.net/traineeship/T9',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        collegeName: $('[name="collegeName"]').val(),
        programName: $('[name="programName"]').val()
      },
      success: function (response) {
        Swal.fire({
          title: "Form Submitted!",
          text: "Thank you for applying to our course! Your response has been received, and we appreciate your commitment to learning",
          icon: "success"
        });
        $('[name="fullName"]').val('');
        $('[name="mobileNo"]').val('');
        $('[name="email"]').val('');
        $('[name="collegeName"]').val('');
        $('[name="programName"]').val('');
      },
      error: function (error) {
        console.error('Error:', error);
      }
    });
  };
  return (
    <div>
    {/* ---------------------Mobile view---------------- */}
    <div className='mobile_CS_program_details_image d-sm-block d-md-none'>
        <div className='container-fluid background_color py-5'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='Details_Main_text'>
                  <h1 className='display-5 pt-5 text-white'>Cyber Security Traineeship Program</h1>
                  <h4 className='text-white pt-2'>Start Learning Cyber Security by Top Industry Experts...</h4>
                  <a href='#CS'><button className="text-white shadow-sm my-4 fs-5 px-4 pt-1 pb-2 Pr_details_button">Read More...</button></a>
              </div>
              </div>
              <div className='col-md-12'>
                <div className='Program_details_form px-3'>
                    <div className='py-4'>
                    <p className='text-center fs-3'>Apply Now</p>
                    <form onSubmit={handleSubmit}>
                          <div class="mt-2">
                            <label for="fullName" class="form-label pb-2 fw-bold contact_form">Full Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && <div className="error text-danger">{nameError}</div>}
                          </div>
                          <div class="mt-2">
                            <label for="email" class="form-label pb-2 fw-bold contact_form">Email Address</label>
                            <input
                              className='form-control'
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && <div className="error text-danger">{emailError}</div>}
                          </div>
                          <div class="mt-2">
                            <label for="mobileNo" class="form-label pb-2 fw-bold contact_form">Phone Number</label>
                            <input
                              className='form-control'
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              value={formData.mobileNo}
                              onChange={handleInputChange}
                              required
                            />
                            {phoneError && <div className="error text-danger">{phoneError}</div>}
                          </div>
                          <div class="my-2">
                            <label for="collegeName" class="form-label pb-2 fw-bold contact_form">College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>
                          <div class="my-2">
                            <label for="programName" class="form-label pb-2  contact_form">Program</label>
                            <input
                              type="text"
                              readonly class="form-control form-control-plaintext"
                              id="programName"
                              placeholder="Your answer"
                              value="Cyber Security"
                              required />
                            {programError && <div className="error text-danger">{programError}</div>}
                          </div>
                          
                        <div className='row mt-2 pt-4'>
                          <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Submit</button>
                          </div>
                        </div>
                    </form>
                    </div>  
                    </div>
              </div>
            </div>
        </div>
    </div>

    {/* ---------------------Desktop View--------------- */}
    <div className='CS_program_details_image d-none d-md-block mt-5'>
        <div className='container-fluid background_color py-5'>
            <div className='row  mt-4'>
              <div className='col-md-7'>
                <div className='px-5 pt-5 Details_Main_text'>
                  <h1 className='display-4 mt-5 pt-5 text-white'>Cyber Security Traineeship Program</h1>
                  <h4 className='text-white  pt-2'>Start Learning Cyber Security by Top Industry Experts...</h4>
                  <a href='#CS'><button className="text-white shadow-sm my-4 fs-5 px-4 pt-1 pb-2 Pr_details_button">Read More...</button></a>
              </div>
              </div>
              <div className='col-md-5 px-5'>
              <div className='container'>
                <div className=''>
                <div className=''>
               <div className='Program_details_form px-5'>
                    <div className='py-4'>
                    <p className='text-center fs-3'>Apply Now</p>
                    <form onSubmit={handleSubmit}>
                          <div class="mt-2">
                            <label for="fullName" class="form-label pb-2 fw-bold contact_form">Full Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && <div className="error text-danger">{nameError}</div>}
                          </div>
                          <div class="mt-2">
                            <label for="email" class="form-label pb-2 fw-bold contact_form">Email Address</label>
                            <input
                              className='form-control'
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && <div className="error text-danger">{emailError}</div>}
                          </div>
                          <div class="mt-2">
                            <label for="mobileNo" class="form-label pb-2 fw-bold contact_form">Phone Number</label>
                            <input
                              className='form-control'
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              value={formData.mobileNo}
                              onChange={handleInputChange}
                              required
                            />
                            {phoneError && <div className="error text-danger">{phoneError}</div>}
                          </div>
                          <div class="my-2">
                            <label for="collegeName" class="form-label pb-2 fw-bold contact_form">College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>
                          <div class="my-2">
                            <label for="programName" class="form-label pb-2  contact_form">Program</label>
                            <input
                              type="text"
                              readonly class="form-control form-control-plaintext"
                              id="programName"
                              placeholder="Your answer"
                              value="Cyber Security"
                              required />
                            {programError && <div className="error text-danger">{programError}</div>}
                          </div>
                          
                        <div className='row mt-2 pt-4'>
                          <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Submit</button>
                          </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>
                </div>
              </div>
              </div>
            </div>
        </div>
    </div>

    <div className='py-5' id='CS'><CS_program_details/></div>
    <div className='Curriculum_Containte_box py-5'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-2'></div>
          <div className='col-md-8'>
          <div className='text-center Curriculum_Main_text'>
                <h1 className='display-5 pb-2'>Course Curriculum</h1>
                <p>A comprehensive and dynamic syllabus designed to empower your skills and propel your success in every aspect of your professional and personal development.</p>
            </div>
          </div>
          <div className='col-md-2'></div>
        </div>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
          <div className='pt-4 d-none d-md-block'>
            <CS_curriculum_page/>
          </div>
          <div className='d-sm-block d-md-none'>
            <CS_mobile_view_curriculum_page/>
          </div>
          <div className='col-md-1'></div>
          </div>
        </div>
      </div>
    </div>
    <div><Certificates/></div>
    <div><CS_Pricing_card/></div>
    <div><All_Program_Mentor/></div>
    <div><CS_Review_Program_Page/></div>
    <div><CS_FAQ_page/></div>
    <div><Counsellor/></div>
    </div>
  )
}

export default CS_page
